import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaAuthModule, OktaConfig } from '@okta/okta-angular';
import { GtagModule } from 'angular-gtag';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EnvServiceProvider, EnvServiceFactory } from './core/providers';
import { NonProductionRouteGuardService } from './core/services';
import { HttpLoggingInterceptor, HttpMockInterceptor, HttpAuthInterceptor } from './core/interceptors';
import { StoreModule } from './store-module';
import { SharedModule } from './shared/shared.module';
import { Title } from '@angular/platform-browser';
import { MaintenanceGuardService } from './core/services/guards';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

// TODO find a better way to handle env than this method
const env = EnvServiceFactory();
const oktaAuth = new OktaAuth(env.okta.oidc);
const moduleConfig: OktaConfig = { oktaAuth };

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    StoreModule,
    SharedModule,
    OktaAuthModule.forRoot(moduleConfig),
    ToastModule,
    GtagModule.forRoot({
      trackingId: env.googleAnalytics.measurementId,
      trackPageviews: true,
      debug: !env.isProduction(),
    }),
  ],
  providers: [
    EnvServiceProvider,
    NonProductionRouteGuardService,
    MaintenanceGuardService,
    Title,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpLoggingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpMockInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
